import { fetchEmployeeRecord } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { EmployeeRecordT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchMyEmployeeRecord(signal?: AbortSignal): Promise<EmployeeRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchEmployeeRecord(config);
  return lotusHealthZod.fetchEmployeeRecordResponse.parse(response.data).employeeRecord;
}
